import { Metadata } from '../models/course-degree-hub.models';

export const SUBJECT_METADATA: Readonly<
	Record<string, Readonly<Metadata & { descriptionWithLocation: string }>>
> = {
	undergraduate: {
		title: '[SUBJECT] Undergraduate Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] undergraduate courses in the UK. Explore [COURSE_COUNT] [SUBJECT] undergraduate courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] undergraduate courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] undergraduate courses - read course reviews, see course requirements and more.',
	},
	postgraduate: {
		title: '[SUBJECT] Postgraduate Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] postgraduate courses in the UK. Explore [COURSE_COUNT] [SUBJECT] postgraduate courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] postgraduate courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] postgraduate courses - read course reviews, see course requirements and more.',
	},
	hnd: {
		title: '[SUBJECT] HND Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] HND courses in the UK. Explore [COURSE_COUNT] [SUBJECT] HND courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] HND courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] HND courses - read course reviews, see course requirements and more.',
	},
	hnc: {
		title: '[SUBJECT] HNC Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] HNC courses in the UK. Explore [COURSE_COUNT] [SUBJECT] HNC courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] HNC courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] HNC courses - read course reviews, see course requirements and more.',
	},
	masters: {
		title: "[SUBJECT] Master's Degrees [LOCATION_1]",
		description:
			"Compare the best [SUBJECT] Master's degrees in the UK. Explore [COURSE_COUNT] [SUBJECT] Master's degrees from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.",
		descriptionWithLocation:
			"Compare the best [SUBJECT] Master's degrees in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] Master's degrees - read course reviews, see course requirements and more.",
	},
	pgce: {
		title: '[SUBJECT] PGCE Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] PGCE courses in the UK. Explore [COURSE_COUNT] [SUBJECT] PGCE courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] PGCE courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] PGCE courses - read course reviews, see course requirements and more.',
	},
	phd: {
		title: '[SUBJECT] PhD Degrees [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] PhD degrees in the UK. Explore [COURSE_COUNT] [SUBJECT] PhD degrees from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] PhD degrees in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] PhD degrees - read course reviews, see course requirements and more.',
	},
	'postgraduate-diploma': {
		title: '[SUBJECT] Postgraduate Diplomas [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] postgraduate diplomas in the UK. Explore [COURSE_COUNT] [SUBJECT] postgraduate diplomas from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] postgraduate diplomas in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] postgraduate diplomas - read course reviews, see course requirements and more.',
	},
	'postgraduate-certificate': {
		title: '[SUBJECT] Postgraduate Certificates [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] postgraduate certificates in the UK. Explore [COURSE_COUNT] [SUBJECT] postgraduate certificates from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] postgraduate certificates in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] postgraduate certificates - read course reviews, see course requirements and more.',
	},
	'access-to-higher-education': {
		title: '[SUBJECT] Access to Higher Education Diplomas [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] access to higher education diplomas in the UK. Explore [COURSE_COUNT] [SUBJECT] access to higher education diplomas from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] access to higher education diplomas in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] access to higher education diplomas - read course reviews, see course requirements and more.',
	},
	foundation: {
		title: '[SUBJECT] Foundation Degrees [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] foundation degrees in the UK. Explore [COURSE_COUNT] [SUBJECT] foundation degrees from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] foundation degrees in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] foundation degrees - read course reviews, see course requirements and more.',
	},
	clearing: {
		title: '[SUBJECT] Clearing Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] clearing courses in the UK. Explore [COURSE_COUNT] [SUBJECT] clearing courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] clearing courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] clearing courses - read course reviews, see course requirements and more.',
	},
	degrees: {
		title: '[SUBJECT] Degrees & Courses [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] degrees & courses in the UK. Explore [COURSE_COUNT] [SUBJECT] degrees & courses from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] degrees & courses in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] degrees & courses - read course reviews, see course requirements and more.',
	},
	'undergraduate-certificate-diplomas': {
		title: '[SUBJECT] Undergraduate Certificates & Diplomas [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] undergraduate certificates & diplomas in the UK. Explore [COURSE_COUNT] [SUBJECT] undergraduate certificates & diplomas from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] undergraduate certificates & diplomas in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] undergraduate certificates & diplomas - read course reviews, see course requirements and more.',
	},
	'postgraduate-certificate-diplomas': {
		title: '[SUBJECT] Postgraduate Certificates & Diplomas [LOCATION_1]',
		description:
			'Compare the best [SUBJECT] postgraduate certificates & diplomas in the UK. Explore [COURSE_COUNT] [SUBJECT] postgraduate certificates & diplomas from [UNIVERSITY_COUNT] UK universities - read course reviews, course requirements and more.',
		descriptionWithLocation:
			'Compare the best [SUBJECT] postgraduate certificates & diplomas in [LOCATION]. See the [UNIVERSITY_COUNT] [LOCATION] universities offering [COURSE_COUNT] [SUBJECT] postgraduate certificates & diplomas - read course reviews, see course requirements and more.',
	},
};

export const HEADER_DATA: Readonly<
	Record<string, Readonly<{ title: string; description: string }>>
> = {
	undergraduate: {
		title: '[SUBJECT] undergraduate courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] undergraduate courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	postgraduate: {
		title: '[SUBJECT] postgraduate courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] postgraduate courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	hnd: {
		title: '[SUBJECT] HND courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] HND courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	hnc: {
		title: '[SUBJECT] HNC courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] HNC courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	masters: {
		title: "[SUBJECT] Master's degrees [LOCATION_1]",
		description:
			"Explore [COURSE_COUNT] [SUBJECT] Master's degrees from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!",
	},
	pgce: {
		title: '[SUBJECT] PGCE courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] PGCE courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	phd: {
		title: '[SUBJECT] PhD degrees [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] PhD degrees from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	'postgraduate-diploma': {
		title: '[SUBJECT] postgraduate diplomas [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] postgraduate diplomas from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	'postgraduate-certificate': {
		title: '[SUBJECT] postgraduate certificates [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] postgraduate certificates from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	'access-to-higher-education': {
		title: '[SUBJECT] access to higher education diplomas [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] access to higher education diplomas from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	foundation: {
		title: '[SUBJECT] foundation degrees [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] foundation degrees from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	clearing: {
		title: '[SUBJECT] Clearing courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] Clearing courses from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	degrees: {
		title: '[SUBJECT] degrees & courses [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] degrees from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	'undergraduate-certificate-diplomas': {
		title: '[SUBJECT] undergraduate certificates and diplomas [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] undergraduate certificates and diplomas from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
	'postgraduate-certificate-diplomas': {
		title: '[SUBJECT] postgraduate certificates and diplomas [LOCATION_1]',
		description:
			'Explore [COURSE_COUNT] [SUBJECT] postgraduate certificates and diplomas from [UNIVERSITY_COUNT] [LOCATION]. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	},
};
